var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 9.97626C0.5 15.2223 4.75329 19.475 10 19.475C15.2467 19.475 19.5 15.2223 19.5 9.97626C19.5 4.73026 15.2467 0.477539 10 0.477539C4.75329 0.477539 0.5 4.73026 0.5 9.97626ZM18.2053 9.97643C18.2053 14.5075 14.5317 18.1807 9.99996 18.1807C5.46825 18.1807 1.79458 14.5075 1.79458 9.97643C1.79458 5.44534 5.46825 1.77216 9.99996 1.77216C14.5317 1.77216 18.2053 5.44534 18.2053 9.97643ZM11.0299 12.2643H11.8929L11.8929 13.4293L8.7464 13.4293L8.7464 12.2643H9.61003L9.61004 9.50224H8.7464V8.24746L11.0299 8.24746L11.0299 12.2643ZM10.8642 6.52053C10.8642 6.9975 10.4774 7.38417 10.0003 7.38417C9.52316 7.38417 9.13637 6.9975 9.13637 6.52053C9.13637 6.04356 9.52316 5.65689 10.0003 5.65689C10.4774 5.65689 10.8642 6.04356 10.8642 6.52053Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.5a637d21345cb6cb113ad57ff85e3011.svg";
export { ForwardRef as ReactComponent };